import Vue from 'vue'
import Router from 'vue-router'
import FrontPage from '@/views/FrontPage.vue'
import EnrollPage from '@/views/Enroll.vue'
import AccountPage from '@/views/Account.vue'
import AboutUsPage from '@/views/AboutUs.vue'
import ScorePage from '@/views/Score.vue'
import RankPage from '@/views/Rank.vue'
import EveryRewardPage from '@/views/EveryRewards.vue'
import ProblemPage from '@/views/Problem.vue'
import RulePage from '@/views/Rule.vue'
import SharePage from '@/views/Share.vue'
import NewsPage from '@/views/News.vue'
import JumpPage from '@/views/Jump.vue'
import UserPage from '@/views/User.vue'
import PreliminaryPage from '@/views/Preliminary.vue'
import RepechargePage from '@/views/Repecharge.vue'
import FinalPersonalPage from '@/views/FinalPersonal.vue'
import FinalGroupPage from '@/views/FinalGroup.vue'
import AOCPage from '@/views/AOC.vue'
import CQPage from '@/views/CQ.vue'
import MdPage from '@/views/Md.vue'
import WapFrontPage from '@/views/WapFrontPage.vue'
import WapRankPage from '@/views/WapRank.vue'
import WapSharePage from '@/views/WapShare.vue'
import ContestPage from '@/views/Contest.vue'
import PaymentPage from '@/views/Payment.vue'
import TimeEndPage from '@/views/TimeEnd.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'frontpage',
      component: FrontPage
    },
    {
      path: '/jump',
      name: 'Jump',
      component: JumpPage
    },
    {
      path: '/end',
      name: 'end',
      component: TimeEndPage
    },
    {
      path: '/contest',
      name: 'contest',
      component: ContestPage
    },
    {
      path: '/pay',
      name: 'payment',
      component: PaymentPage
    },
    {
      path: '/md/:link',
      name: 'markdown',
      component: MdPage
    },
    {
      path: '/wap/index',
      name: 'wapfrontpage',
      component: WapFrontPage
    },
    {
      path: '/wap/rank',
      name: 'waprankpage',
      component: WapRankPage
    },
    {
      path: '/wap/share',
      name: 'WapSharePage',
      component: WapSharePage
    },
    {
      path: '/user',
      name: 'User',
      component: UserPage
    },
    {
      path: '/preliminary',
      name: 'Preliminary',
      component: PreliminaryPage
    },
    {
      path: '/repecharge',
      name: 'Repecharge',
      component: RepechargePage
    },
    {
      path: '/aoc',
      name: 'AOC',
      component: AOCPage
    },
    {
      path: '/cq',
      name: 'CQ',
      component: CQPage
    },
    {
      path: '/final-personal',
      name: "FinalPersonal",
      component: FinalPersonalPage
    },
    {
      path: '/final-group',
      name: "FinalGroup",
      component: FinalGroupPage
    },
    {
      path: '/share/:uuid/:title',
      name: 'Share',
      component: SharePage,
    },
    {
      path: '/score',
      name: 'score',
      component: ScorePage
    },
    {
      path: '/rewards',
      name: 'reward',
      component: EveryRewardPage
    },
    {
      path: '/rank/:me',
      name: 'rank',
      component: RankPage
    },
    {
      path: '/news',
      name: 'news',
      component: NewsPage
    },
    {
      path: '/problem',
      name: 'problem',
      component: ProblemPage
    },
    {
      path: '/enroll',
      name: 'enroll',
      component: EnrollPage
    },
    {
      path: '/event',
      name: 'rule',
      component: RulePage
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: AboutUsPage
    },
    {
      path: '/account/:type',
      name: 'account',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: AccountPage
      // import(/* webpackChunkName: "about" */ './views/About.vue')
    },

  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
